import { useState, useEffect } from 'react';
import { AnalyticsData } from '../types/dashboard';
import DashboardAnalytics from './DashboardAnalytics';

interface DashboardAnalyticsViewProps {
  userId: string;
}

export default function DashboardAnalyticsView({ userId }: DashboardAnalyticsViewProps) {
  const [analytics, setAnalytics] = useState<AnalyticsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, [userId]);

  const fetchAnalytics = async () => {
    try {
      const response = await fetch('/api/dashboard/analytics');
      const data = await response.json();
      setAnalytics(data.analytics);
    } catch (error) {
      console.error('Failed to fetch analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-coral-500 border-t-transparent"></div>
      </div>
    );
  }

  if (!analytics || analytics.requestsOverTime.length === 0) {
    return (
      <div>
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Analytics & Performance</h2>
          <p className="text-gray-600">Detailed metrics and performance analysis</p>
        </div>

        <div className="text-center py-12 bg-white rounded-2xl border border-gray-200">
          <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Analytics Data Yet</h3>
          <p className="text-gray-500 max-w-md mx-auto">
            Start making API requests to see detailed analytics, performance metrics, and error monitoring.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Analytics & Performance</h2>
        <p className="text-gray-600">Detailed metrics and performance analysis</p>
      </div>

      {/* Request & Endpoint Analytics */}
      <DashboardAnalytics analytics={analytics} />
    </div>
  );
}
